import { BodyBlockProps } from '../../../components/blocks';

// Define the Directus type
export interface DirectusBodyBlock {
  id?: number;
  body_item?: string;
}

export const mapDirectusBodyBlock = (block: DirectusBodyBlock): BodyBlockProps => {
  return {
    body: block.body_item,
  };
};
